export default __webpack_public_path__ + "static/media/dp-js-react.b26ddf0e.png";